import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-updating',
  templateUrl: '../templates/loading.component.html',
  styleUrls: ['../templates/styles/loading.component.css']
})
export class LoadingUpdatingComponent {
  isLoading: boolean = true;

  // Метод для установки состояния загрузки
  setLoading(loading: boolean) {
    this.isLoading = loading;
  }
}
